import React from 'react';
import Header from '../../components/Header';
import HeaderImage from '../../images/job-interview8.jpg';
import StoryImage from '../../images/job-interview2.jpg';

import MissionImage from '../../images/job-interview4.jpg';
import './about.css';

const About = () => {
    return (
        <div className="page-content">
            <Header title="About Us" image={HeaderImage}>
                Upgrade hiring and admissions with First Take Interviews. Replace outdated text and phone calls with advanced video references for more accurate and efficient evaluations. Make confident, people-focused decisions with our innovative solution.
            </Header>

            <section className="about__story">
                <div className="about__story-container">
                    <div className="about__section-image">
                        <img src={StoryImage} alt="Our Story" />
                    </div>
                    <div className="about__section-content">
                        <h1>First Take Interviews</h1>
                        <p>First Take Interviews was founded by Brian Griffiths. Brian has been a very successful and
                            well respected Canadian based Senior Client Relationship and Technical Recruiting Specialist
                            for 27 years.</p>
                        <p>The company was founded on the idea of saving companies time, money and creating
                            pinpoint efficiency the hiring process for key personnel. The value component is two fold:</p>
                        <p>1) We interview by video preselected candidates that you have identified through your
                            search engines or other methodologies. The compacted video interviews we send you –
                            15 to 20 minutes maximum - will help you to identify within short order as to whether the
                            candidate you’ve selected for an initial discussion has the required communication skills
                            required for the role.</p>
                         <p>2) The responses to the priority level questions you have provided us will help you to
                            determine in relatively short order as to whether the person has the experience and
                            technical acumen you require for the position.</p>
                         <p>This is not AI based technology we are utilizing. No one can truly place human to human
                            evaluation.</p>   
                    </div>
                </div>
            </section>

          

            <section className="about__mission">
                <div className="about__mission-container">
                    <div className="about__section-image">
                        <img src={MissionImage} alt="Our Mission" />
                    </div>
                    <div className="about__section-content">
                        <h1>Our Mission</h1>
                        <p>Our mission at First Take Interviews is to transform the hiring
                        process. It’s time to replace outdated interview processes and reference
                        gathering methodology with efficient use of candidate videos.</p>
                        
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
